import PropTypes from 'prop-types'

import './FormControls.scss'

export default function FormField({ label, htmlFor, optional, hint, error, className, children }) {
  const errorMessage = Array.isArray(error) ? error[0] : error

  return (
    <div className={`form-field ${className || ''}`.trim()}>
      {label && (
        <label className="form-field__label" htmlFor={htmlFor}>
          {label}
          {optional && <span className="form-field__optional">(optional)</span>}
        </label>
      )}
      {children}
      {errorMessage && <span className="form-field__error">{errorMessage}</span>}
      {hint && !errorMessage && <p className="form-field__hint">{hint}</p>}
    </div>
  )
}

FormField.propTypes = {
  label: PropTypes.node,
  htmlFor: PropTypes.string,
  optional: PropTypes.bool,
  hint: PropTypes.node,
  error: PropTypes.oneOfType([PropTypes.string, PropTypes.node, PropTypes.arrayOf(PropTypes.node)]),
  className: PropTypes.string,
  children: PropTypes.node.isRequired,
}

